module.exports = __webpack_public_path__ + "media/images/guideline/I_01-6478838c84d138581360414c31bef107.jpg";